interface ActionConfirmOpts {
  title: string;
  sub?: string;
  warning?: string;
  confirmLabel?: string;
  onConfirm?: () => void;
}

export function openActionConfirm(opts: ActionConfirmOpts) {
  window.dispatchEvent(new CustomEvent("blyn:action-confirm", { detail: opts }));
}
